module.exports = __webpack_public_path__ + "media/images/athletes/3516-297502b5613a2449484dab4c753aa1f3.png";